export default {
  /* Events */
  assistantsExportedSuccessfully: 'Assistenten erfolgreich exportiert',
  createEvent: 'Erstellen eines Ereignisses',
  mustChargeBeforeCreateEvents: 'Sie müssen Geld berechnen, bevor Sie Ereignisse erstellen',
  events: 'Ereignisse',
  published: 'Veröffentlicht',
  notPublished: 'Nicht veröffentlicht',
  soldOut: 'Ausverkauft',
  publishEventToBeShownInSalesLists: 'Veröffentlichen dieses Ereignisses, das in Verkaufslisten angezeigt werden soll',
  loadingEvents: 'Laden von Ereignissen',
  noEventsRegistered: 'Keine Veranstaltungen registriert',
  publish: 'Veröffentlichen',
  soldTickets: 'Verkaufte Tickets',
  availableTickets: 'Verfügbare Tickets',
  totalTickets: 'Ticketbetrag',
  eventStateUpdated: 'Ereignisstatus aktualisiert',
  profileImage: 'Profilbild',
  thePicture: 'Das Bild',
  thePictures: 'Die Bilder',
  theBanner: 'Das Banner',
  createPromotor: 'Erstellen von Promotor',
  mustChargeBeforeCreatingPromotors: 'Sie müssen Geld berechnen, bevor Sie Promotoren erstellen',
  promotors: 'Promotoren',
  showUrlToPromotor: 'URL zu promotor anzeigen',
  editPromotor: 'Bearbeiten von Promotor',
  setProfilePicture: 'Festlegen des Profilbilds',
  setBanner: 'Set-Banner',
  deletePromotor: 'Löschen promotor',
  loadingPromotor: 'Ladepromotoren',
  noPromotorsRegistered: 'Es sind keine Promotoren registriert',
  eventRating: 'Evenementbeoordeling',
  priceRating: 'Prijs rating',
  profitability: 'Rentabilität',
  businessFee: 'Geschäftsgebühr',
  gatewayFee: 'Gateway-Gebühr',
  totalProfit: 'Gesamtgewinn',
  tags: 'Tags',
  createTag: 'Maak een tag',
  purchase: 'Kauf',
  /* End Events */
  createProductsCategory: 'Produkt erstellen',
  mustChargeBeforeCreatingProductsCategories: 'Sie müssen Geld berechnen, bevor Sie Produkte erstellen',
  successfullyCreatedProductCategory: 'Product succesvol gemaakt',
  successfullyUpdatedProductCategory: 'Product geüpdatet',
  productsCategories: 'Produkte',
  newProductsCategory: 'Neues Produkt',
  editProductsCategory: 'Bearbeiten des Produkts',
  photos: 'Fotos',
  setProductsCategoryPhoto: 'Festlegen des Produktfotos',
  deleteProductsCategory: 'Produkt löschen',
  loadingProductsCategory: 'Laden von Produkten',
  noProductsCategoriesRegistered: 'Es sind keine Produkte registriert',
  doYouWantToDeleteProductsCategory: 'Möchten Sie das Produkt löschen?',
  price: 'Preis',
  discountPrice: 'Rabattpreis',
  stock: 'Lager',
  createProduct: 'Produkt erstellen',
  mustChargeBeforeCreatingProducts: 'Sie müssen Geld berechnen, bevor Sie Produkte erstellen',
  products: 'Produkte',
  newProduct: 'Neues Produkt',
  editProduct: 'Bearbeiten des Produkts',
  // // photos: 'Fotos',
  setProductPhoto: 'Festlegen des Produktfotos',
  deleteProduct: 'Produkt löschen',
  loadingProduct: 'Laden von Produkten',
  noProductsRegistered: 'Es sind keine Produkte registriert',
  doYouWantToDeleteProduct: 'Möchten Sie das Produkt löschen?',
  purchaseId: 'id',
  purchasePaymentMethod: 'Zahlungsarten',
  shippingAddress: 'Versandadresse',
  paymentDate: 'Zahlungsdatum',
  createProductPurchase: 'Produktkauf erstellen',
  mustChargeBeforeCreatingProductPurchases: 'Sie müssen Geld berechnen, bevor Sie Produktkäufe erstellen',
  productPurchases: 'Produktkäufe',
  newProductPurchase: 'Kauf neuer Produkte',
  editProductPurchase: 'Bearbeiten des Produktkaufs',
  deleteProductPurchase: 'Produktkauf löschen',
  loadingProductPurchase: 'Laden von Produktkäufen',
  noProductPurchasesRegistered: 'Es sind keine Produktkäufe registriert',
  doYouWantToDeleteProductPurchase: 'Möchten Sie den Produktkauf löschen?',
  provider: 'Anbieter',
  providers: 'Anbieter',
  createProvider: 'Anbieter erstellen',
  mustChargeBeforeCreatingProviders: 'Sie müssen Geld berechnen, bevor Sie Anbieter erstellen',
  newProvider: 'Neuer Anbieter',
  editProvider: 'Edit-Anbieter',
  deleteProvider: 'Anbieter löschen',
  loadingProvider: 'Laden von Anbietern',
  noProvidersRegistered: 'Es sind keine Anbieter registriert',
  doYouWantToDeleteProvider: 'Möchten Sie den Anbieter löschen?',
  providerHasBeenDeleted: 'Der Anbieter wurde erfolgreich gelöscht',
  fabric: 'Stoff',
  fibre: 'Fibre',
  key: 'Schlüssel',
  positionArc: 'Position Bogen',
  acab: 'Acab',
  acabado: 'Acabado',
  refChina: 'Referenz China',
  refClient: 'Referenzclient',
  label: 'Etikett',
  wide: 'Breite',
  weight: 'Gewicht',
  composition: 'Zusammensetzung',
  perfomance: 'Performance',
  unitMeasure: 'Einheitsmaß',
  cantMtsFinals: 'cant Mts Finale',
  cantKlsFinals: 'cant Kls Finale',
  cantMtKl: 'cant Mt Kl',
  capMaxKl: 'Kappe Max Kl',
  portOcupation: 'Port Ocupation',
  productHasBeenDeleted: 'Das Produkt wurde erfolgreich gelöscht',
  attachEventsInYourWebSite: 'Einfügen von Ereignissen in Ihre Website',
  createDivElementToAttachEventsInYourWebSite: 'Um Ereignisse an Ihre Website anzuhängen, müssen Sie ein div-Element mit der ID',
  andOtherWithTheId: 'und andere mit der ID',
  inYourSiteBody: 'Im Body-Tag Ihrer Website',
  andThenAddTheNextScriptInTheFooter: 'Und fügen Sie dann das nächste Skript zur Fußzeile Ihrer Website hinzu.',
  scriptCopied: 'Skript kopiert',
  errorCopyingTheScript: 'Fehler beim Kopieren des Skripts',
  exportAssistants: 'Exportassistenten',
  assistantsList: 'Assistentenliste',
  assistantId: 'Assistant-ID',
  loadingAssistants: 'Ladeassistenten',
  noAssistantsRegistered: 'Es sind keine registrierten Assistenten vorhanden.',
  registerDate: 'Registerdatum',
  automatic: 'Automatisch',
  manual: 'Manuell',
  creationType: 'Erstellungstyp',
  errorLoadingEvent: 'Beim Laden des Ereignisses ist ein Fehler aufgetreten.',
  eventNotPublishedAndOutOfLists: 'Ihr Ereignis wurde nicht veröffentlicht, und es wird nicht in den Listen angezeigt werden, bis es',
  eventDate: 'Ereignisdatum',
  publishEvent: 'Veröffentlichungsereignis',
  seePromotorInYourWebSite: 'Siehe promotor in Ihrer Website',
  mustDoToSeePromotorInWebSite: 'Um den Motor zu sehen, müssen Sie sicher sein, dass das Ereignis-Widget in Ihrer Website angehängt ist, um die nächste URL',
  copy: 'Kopieren',
  mustContactSupportToSeePromotorInWebSite: 'Um den Promotor zu sehen, müssen Sie den Support kontaktieren, um eine URL zu erhalten',
  errorCopyingUrl: 'Fehler beim Kopieren der URL',
  urlCopied: 'Url kopiert',
  eventContacts: 'Eventkontakte',
  doYouWantToDeletePromotor: 'Möchten Sie den Promotor löschen?',
  /* Djs */
  view: 'Aussicht',
  djSuccessfullyCreated: 'DJ erfolgreich erstellt',
  djSuccessfullyUpdated: 'DJ erfolgreich aktualisiert',
  createDj: 'dj erstellen',
  mustChargeBeforeCreatingDjs: 'Sie müssen Geld verlangen, bevor Sie djs erstellen',
  djs: 'Djs',
  followers: 'Anhänger',
  showUrlToDj: 'Url bis dj anzeigen',
  editDj: 'Dj bearbeiten',
  deleteDj: 'Dj löschen',
  loadingDj: 'Laden von djs',
  noDjsRegistered: 'Es sind keine djs registriert',
  doYouWantToDeleteDj: 'Möchten Sie den DJ löschen??',
  seeDjInYourWebSite: 'Siehe dj in Ihrer Website',
  mustDoToSeeDjInWebSite: 'Um den dj zu sehen, müssen Sie sicher sein, dass Sie das Veranstaltungs-Widget auf Ihrer Website angehängt haben, um die nächste url',
  mustContactSupportToSeeDjInWebSite: 'Um den dj zu sehen, müssen Sie sich an den Support wenden, um eine url',
  /* End Djs */
  importAssistants: 'Importassistenten',
  event: 'Ereignis',
  assistantsImportedSuccessfully: 'Assistenten erfolgreich importiert',
  format: 'Format',
  editEvent: 'Bearbeiten des Ereignisses',
  newEvent: 'Neue Veranstaltung',
  shortDescription: 'Kurzbeschreibung',
  note: 'Hinweis',
  insertNoteToSendInConfirmationEmail: 'Einfügen einer Notiz zum Senden der Bestätigungs-E-Mail',
  isAnOnlineEvent: 'Es ist eine Online-Veranstaltung',
  eventUrl: 'URL des Ereignisses',
  category: 'Kategorie',
  startDate: 'Startdatum',
  finishDate: 'Endtermin',
  startDateAccess: 'Startdatum',
  finishDateAccess: 'Endtermin',
  /* Places */
  place: 'Ort',
  latitude: 'Breitengrad',
  longitude: 'Länge',
  organizer: 'Veranstalter',
  limitRegisterByIdentificationDocument: 'Begrenzungsregister nach Identifikationsbeleg',
  cover: 'Cover',
  pictures: 'Fotos | Foto',
  eventCreated: 'Event erstellt',
  promoter: 'Promotor',
  locationUrl: 'Url zu Standort',
  facebookMessageSendingUrl: 'Facebook-Nachricht senden Url',
  facebookSiteUrl: 'Facebook-Seite Url',
  completeRequiredFields: 'Füllen Sie die erforderlichen Felder aus',
  promoterSuccessfullyCreated: 'Promotor wurde erfolgreich erstellt',
  promoterSuccessfullyUpdated: 'Promotor wurde erfolgreich aktualisiert',
  eventSocialNetworks: 'Veranstaltung soziale Netzwerke',
  socialNetworkSelect: 'Wählen Sie das soziale Netzwerk',

  doYouWantDuplicate: 'Möchten Sie diesen Ort duplizieren?',
  isPlaceActive: 'Ist dieser Ort aktiv?',
  isThisPlaceRestaurant: 'Dieser Ort ist ein Restaurant',
  configPlace: 'Konfiguration platzieren',
  placeRating: 'Plaats ranking',
  placeTags: 'Tags Ihres Platzes',
  tagsHint: 'Geben Sie ein Tag ein und drücken Sie die Enter',
  pleaseTypeLocation: 'Geben Sie Ihre Adresse ein',
  diningStyle: 'Essstil',
  dressCode: 'Kleiderordnung',
  acceptedPaymentMethods: 'Akzeptierte Zahlungsmethoden',
  parkingType: 'Parkart',
  casual: 'Casual',
  businessCasual: 'Business casual',
  casualElegant: 'Casual elegant',
  formal: 'Formal',
  jacketRequired: 'Jacket required',
  jacketAndTie: 'Jacket and tie',
  priceAverage: 'Preisdurchschnitt',
  brunch: 'Brunch',
  lunch: 'Mittagessen',
  happyHour: 'Happy Hour',
  dinner: 'Abendessen',
  daily: 'Täglich',
  /* End Places */

  urlOrLink: 'URL oder Link',
  socialNetworkAdd: 'Hinzufügen eines sozialen Netzwerks',
  eventCurrency: 'Ereigniswährung',
  ticketTitle: 'Tickettitel',
  ticketPrice: 'Ticketpreis',
  ticketingServicePrice: 'Ticketing-Servicepreis',
  startOfSale: 'Start des Verkaufs',
  endOfSale: 'Ende des Verkaufs',
  ticketsNumber: 'Anzahl der Tickets',
  maxTicketsPerPerson: 'Maximale Anzahl Tickets pro Person',
  deleteTicket: 'Ticket löschen',
  addTicket: 'Ticket hinzufügen',
  result: 'Ergebnis',
  ofPromoter: 'des Promotors',
  upload: 'Hochladen',
  allowedFormats: 'Nur diese Formate sind zulässig',
  maxPictureSize: 'Bild muss eine maximale Größe von',
  and: 'Und',
  dragAndDropFile: 'Ziehen Und ablegen Sie die Datei hier',
  imageSuccessfullyLoaded: 'Bild erfolgreich geladen',
  deleteSelection: 'Auswahl löschen',
  analyze: 'Analysieren',
  atLeastOneFileToContinue: 'Geben Sie mindestens eine Datei ein, um fortzufahren',
  nextStep: 'Nächster Schritt',
  theFile: 'Die Datei',
  notAccepted: 'wurde nicht akzeptiert',
  seeEvent: 'Siehe Ereignis',
  registerAttender: 'Registrierungsassistent',
  advancedSearch: 'Erweiterte Suche',
  assistantsPerPage: 'Assistenten pro Seite',
  assistantName: 'Name des Assistenten',
  creation: 'Kreation',
  ticket: 'Ticket',
  register: 'Registrieren',
  assistantRegistered: 'Assistent registriert',
  buyer: 'Käufer',
  cost: 'Kosten',
  parallelAnswer: 'Parallele Antwort',
  franchise: 'Franchise',
  bank: 'Bank',
  ofPurchase: 'des Kaufs',
  download: 'Herunterladen',
  dataCopied: 'Kopierte Daten',
  errorTryAgain: 'Ein Fehler ist aufgetreten, versuchen Sie es erneut',
  checkInState: 'Check-in-Status',
  check: 'prüfen',
  checkedIn: 'Eingecheckt',
  unCheck: 'Deaktivieren',
  zipCode: 'Postleitzahl',
  currency: 'Währung'
}
